import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import InsuredSectionDropdown from '../InsuredSectionDropdown';

import AttachmentIconTray from './components/AttachmentIconTray';
import AttachmentsTable from './components/AttachmentsTable';

const RecordAttachments = ({ recordId }) => (
  <InsuredSectionDropdown
    openByDefault
    icons={<AttachmentIconTray recordId={recordId} />}
    title="Record Attachments"
  >
    <Flex alignItems="center" bg="white" justifyContent="center">
      <AttachmentsTable recordId={recordId} />
    </Flex>
  </InsuredSectionDropdown>
);

RecordAttachments.propTypes = { recordId: PropTypes.number.isRequired };

export default RecordAttachments;
